import { FormItem, Checkbox } from '@vkontakte/vkui';
import React from 'react';
import PropTypes from 'prop-types';
import('./AddJoinedMembersComponent.css');

export const AddJoinedMembersComponent = ({checked, onChange, disabled, label}) => {
  if (disabled) {
    return null;
  }

  return (<FormItem
    className={'AddJoinedMembersComponent'}
  >
    <Checkbox
      description={label}
      checked={checked}
      onChange={onChange}
    >
    </Checkbox>
  </FormItem>);
}

AddJoinedMembersComponent.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
};
